import { isNil } from "lodash-es";

import { IAssignmentsURLFilter } from "@/data/assignments";
import { ICodelist } from "@/data/codelists";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { TType } from "@/types";

export const assignmentsFiltersMapper: TType<IAssignmentsURLFilter> = {
  query: (v: string) => (isNil(v) ? undefined : v),
  status: (v: ICodelist[]) => (isNil(v) ? undefined : v.map(o => o.code)),
  startDateArray: (v: string) => (isNil(v) ? undefined : v),
  endDateArray: (v: string) => (isNil(v) ? undefined : v),
  contactPersonId: (v: Array<IConsultantProfile["id"]>) => (isNil(v) ? undefined : v),
};
